"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioQuestion = exports.YesNoRadioQuestion = exports.YES_NO = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_spacer_1 = require("@travelnest/merlin.spacer");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const React = __importStar(require("react"));
const Radio_1 = require("./Radio");
exports.YES_NO = {
    'Yes': true,
    'No': false,
};
const Wrapper = styled_1.default.div `
	.radio-question__question {
		padding-top: 20px;
	}


`;
const Legend = styled_1.default.legend `
	${merlin_theme_1.default.typography.b1}
`;
const Fieldset = styled_1.default.fieldset ` border: 0; `;
const YesNoRadioQuestion = (props) => {
    return React.createElement(exports.RadioQuestion, Object.assign({}, props, { options: exports.YES_NO }));
};
exports.YesNoRadioQuestion = YesNoRadioQuestion;
const RadioQuestion = (props) => {
    const { question, options, onChange, id, selected } = props;
    const radioClickHandler = (_, name, value) => {
        if (onChange) {
            onChange(name, value);
        }
    };
    const radios = Object.entries(options).map(([l, v], idx) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Radio_1.Radio, { key: l, name: l, value: v, checked: selected === v, onChange: radioClickHandler, label: l, activeHighlightStyle: props.activeHighlightStyle }),
            idx !== Object.entries(options).length - 1 && React.createElement(merlin_spacer_1.Spacer, { spacing: "small" })));
    });
    return React.createElement(Wrapper, { "data-testid": id },
        React.createElement(Fieldset, null,
            React.createElement(Legend, null, question),
            React.createElement(merlin_spacer_1.Spacer, { spacing: "small" }),
            radios));
};
exports.RadioQuestion = RadioQuestion;
//# sourceMappingURL=RadioQuestion.js.map